<template>
  <div class="don">
    <BreadsCrums page="joinUs" previous="home" />
    <section class="our-testimonial-v2 garden-set-pd-sm">
      <div class="container">
        <div class="garden-title text-center">
          <h3>{{ $t("navBar.interrested") }}</h3>
        </div>
        <ul class="row">
          <li class="col-md-12 col-sm-12">
            <div class="box">
              <div class="name">
                <h3>{{ $t("devenezParrain") }}</h3>
              </div>
              <div class="box-content">
                <p>{{ $t("devenezParrainText") }}</p>
              </div>
            </div>
          </li>
          <li class="col-md-12 col-sm-12">
            <div class="box">
              <div class="name">
                <h3>{{ $t("devenezMembre") }}</h3>
              </div>
              <div class="box-content">
                <p>{{ $t("devenezMembreText") }}</p>
              </div>
            </div>
          </li>
          <li class="col-md-12 col-sm-12">
            <div class="box">
              <div class="name">
                <h3>{{ $t("devenezSponsor") }}</h3>
              </div>
              <div class="box-content">
                <p>{{ $t("devenezSponsorText") }}</p>
              </div>
            </div>
          </li>
          <li class="col-md-12 col-sm-12">
            <div class="box">
              <div class="name">
                <h3>{{ $t("entronsEnPartenariat") }}</h3>
              </div>
              <div class="box-content">
                <p>{{ $t("entronsEnPartenariatText") }}</p>
              </div>
            </div>
          </li>
          <li class="col-md-12 col-sm-12">
            <div class="box">
              <div class="name">
                <h3>{{ $t("clientsPotentiels") }}</h3>
              </div>
              <div class="box-content">
                <p>{{ $t("clientsPotentielsText") }}</p>
              </div>
            </div>
          </li>
          <li class="col-md-12 col-sm-12"></li>
        </ul>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  created() {
    document.title = this.$i18n.t("navBar.interrested");
  },
  name: "JoinUs"
};
</script>
<style scoped>
.our-testimonial-v2 .box {
  padding: 55px 30px 45px 30px;
  border-radius: 15px;
  position: relative;
}
.box .name {
  padding: 15px !important;
  border-radius: 8px;
  top: -27px;
}
.box-content {
  margin-left: 05px !important;
  text-align: justify;
}
.box-content p {
  color: black !important;
  font-size: 16px !important;
}

@media (max-width: 767px) {
  .our-mission {
    margin-top: -250px !important;
    padding-top: 50px;
  }
}
@media (min-device-width: 320px) and (max-device-width: 480px) {
  .name h3 {
    font-size: 15px !important;
    text-align: center;
  }
  .box .name {
    padding: 4px;
    width: 250px;
  }
  .box-content p {
    text-align: justify;
  }
}
@media (max-device-width: 320px) {
  .name h3 {
    font-size: 15px !important;
    text-align: center;
  }
  .box .name {
    padding: 4px;
    width: 250px;
  }
  .box-content p {
    text-align: justify;
  }
}
</style>
